import React from 'react';
import {Route, Switch, useRouteMatch} from 'react-router-dom';
import CustomerFeedback from 'routes/App/feedback/CustomerFeedback';

const FeedbackRoutes = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={match.path} component={CustomerFeedback} />
    </Switch>
  );
};

export default FeedbackRoutes;
